module.exports = __webpack_public_path__ + "components/outside-promo-page/static/mobile-464b9dd13d9d80a2b4c63b4a5b67aecf.webp";